<template>
  <div class="chart-container">
    <canvas :id="chartId" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'BarChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      chart: null,
      chartId: 'bar-chart-' + Math.random().toString(36).substring(2, 9)
    };
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  mounted() {
    this.createChart();
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    createChart() {
      const canvas = document.getElementById(this.chartId);
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  if (context.parsed.y !== null) {
                    label += new Intl.NumberFormat('pt-BR', { 
                      style: 'currency', 
                      currency: 'BRL' 
                    }).format(context.parsed.y);
                  }
                  return label;
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return new Intl.NumberFormat('pt-BR', { 
                    style: 'currency', 
                    currency: 'BRL',
                    maximumFractionDigits: 0
                  }).format(value);
                }
              }
            }
          }
        }
      });
    },
    updateChart() {
      if (!this.chart) {
        this.createChart();
        return;
      }
      
      this.chart.data = this.chartData;
      this.chart.update();
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
}
</style> 